import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { Slider } from "primereact/slider";
import React, { useState } from "react";
import { StudentAvailability } from "../misc/StudentAvailability";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";

const SingleLessonStep = ({
  singleLessonData,
  setSingleLessonData,
  availability,
  setAvailability,
  handleChange,
  input,
}) => {
  const formatDuration = (value) => {
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    return `${hours ? `${hours} hour${hours > 1 ? "s" : ""}` : ""}${
      minutes ? ` ${minutes} minute${minutes > 1 ? "s" : ""}` : ""
    }`;
  };
  const [termsModalVisible, setTermsModalVisible] = useState(false);
  return (
    <div className="w-full" style={{ opacity: 1, backgroundColor: "" }}>
      <div
        className="mb-4"
        style={{
          borderRadius: "10px",
          padding: "10px",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        }}
      >
        <div className="d-grid">
          <div className="col-12 flex justify-content-center align-items-center">
            <StudentAvailability
              readOnly={false}
              availability={availability}
              setAvailability={setAvailability}
            />
          </div>
          {/* <div className="col-12">
            <label>Date</label>
            <Calendar
              value={singleLessonData.date}
              onChange={(e) => {
                setSingleLessonData((prevData) => ({
                  ...prevData,
                  date: e.value,
                }));
              }}
              className="w-100"
              showTimeSelect
              dateFormat="dd/M/yy"
            />
          </div>
          <div className="col-12">
            <label>Time</label>
            <InputText
              value={singleLessonData.startTime}
              type="time"
              timeFormat="h:mm aa"
              onChange={(e) => {
                setSingleLessonData((prevData) => ({
                  ...prevData,
                  startTime: e.target.value,
                }));
              }}
              className="w-100"
            />
          </div> */}

          <div>
            <div className="col-12">
              <label>Duration</label>
              <Slider
                className="my-2 mb-2 w-100"
                id="duration"
                value={singleLessonData.duration}
                onChange={(e) => {
                  const possibleValues = [120, 240, 360];

                  // Find the closest predefined value
                  const closestValue = possibleValues.reduce((prev, curr) =>
                    Math.abs(curr - e.value) < Math.abs(prev - e.value)
                      ? curr
                      : prev
                  );

                  setSingleLessonData((prevData) => ({
                    ...prevData,
                    duration: closestValue,
                  }));
                }}
                min={120}
                max={360}
                step={1}
                pt={{
                  track: {
                    style: {
                      height: "10px",
                      background:
                        "linear-gradient(to right, transparent 0%, black 0%, black 1%, transparent 1%, transparent 49.5%, black 49.5%, black 50.5%, transparent 50.5%, transparent 99%, black 99%, black 100%)",
                      backgroundSize: "100% 100%",
                      backgroundRepeat: "no-repeat",
                    },
                  },
                  handle: { style: { width: "24px", height: "24px" } },
                }}
              />

              {/* Labels Below the Slider */}
              <div className="d-flex justify-content-between position-relative mt-1 w-100 mb-3">
                <span
                  style={{
                    position: "absolute",
                    left: "0%",
                    transform: "translateX(-10%)",
                    whiteSpace: "nowrap", // Prevents wrapping
                    minWidth: "60px", // Ensures text doesn’t shrink
                    textAlign: "left",
                  }}
                >
                  2 Hours
                </span>
                <span
                  style={{
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                    whiteSpace: "nowrap",
                    minWidth: "60px",
                    textAlign: "center",
                  }}
                >
                  4 Hours
                </span>
                <span
                  style={{
                    position: "absolute",
                    left: "100%",
                    transform: "translateX(-90%)",
                    whiteSpace: "nowrap",
                    minWidth: "60px",
                    textAlign: "right",
                  }}
                >
                  6 Hours
                </span>
              </div>

              {/* <Slider
                className="mt-2 mb-2 w-100"
                id="duration"
                value={singleLessonData.duration}
                onChange={(e) => {
                  const possibleValues = [120, 240, 360];

                  // Find the closest predefined value
                  const closestValue = possibleValues.reduce((prev, curr) =>
                    Math.abs(curr - e.value) < Math.abs(prev - e.value)
                      ? curr
                      : prev
                  );

                  setSingleLessonData((prevData) => ({
                    ...prevData,
                    duration: closestValue,
                  }));
                }}
                min={120}
                max={360}
                step={1} // Allows precise selection, but snaps to the closest valid value
                pt={{
                  root: { style: { cursor: "pointer" } }, // Makes the whole track clickable
                  handle: { style: { width: "24px", height: "24px" } }, // Bigger handle for easier dragging
                  track: { style: { height: "10px" } }, // Increases track thickness for better interaction
                }}
                onClick={(e) => {
                  const possibleValues = [120, 240, 360];

                  // Calculate percentage clicked on the slider track
                  const trackRect = e.currentTarget.getBoundingClientRect();
                  const clickPosition = e.clientX - trackRect.left;
                  const clickPercentage = clickPosition / trackRect.width;

                  // Map click position to one of the three values
                  const closestValue =
                    possibleValues[
                      Math.round(clickPercentage * (possibleValues.length - 1))
                    ];

                  setSingleLessonData((prevData) => ({
                    ...prevData,
                    duration: closestValue,
                  }));
                }}
              /> */}

              {/* <Slider
                className="mt-2 mb-2 w-100"
                id="duration"
                value={singleLessonData.duration}
                onChange={(e) => {
                  const possibleValues = [120, 240, 360];

                  // Find the closest value from the possibleValues array
                  const closestValue = possibleValues.reduce((prev, curr) =>
                    Math.abs(curr - e.value) < Math.abs(prev - e.value)
                      ? curr
                      : prev
                  );
                  // console.log(e.value);
                  setSingleLessonData((prevData) => ({
                    ...prevData,
                    duration: closestValue,
                    // duration: e.value,
                  }));
                }}
                min={120}
                max={360}
                step={120}
              /> */}
              {/* <span>
                Selected Duration: {formatDuration(singleLessonData?.duration)}
              </span> */}
            </div>
          </div>

          <div className=" w-100  col-6">
            <div className="d-flex align-items-center justify-content-center">
              <div
                className="select-container"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "center",
                  height: "max-content",
                }}
              >
                <strong className="mb-2">Pick a gearbox </strong>
                <div className="p-field-radiobutton flex flex-column justify-content-center align-items-center mx-3">
                  <div className="flex justify-content-start align-items-center w-full mb-2">
                    <RadioButton
                      inputId="manual"
                      name="transmission"
                      value="manual"
                      onChange={handleChange}
                      checked={input.transmission === "manual"}
                    />
                    <label htmlFor="manual" className="mx-2">
                      Manual
                    </label>
                  </div>
                  <div className="flex justify-content-start align-items-center w-full">
                    <RadioButton
                      inputId="automatic"
                      name="transmission"
                      value="automatic"
                      onChange={handleChange}
                      checked={input.transmission === "automatic"}
                    />
                    <label htmlFor="automatic" className="mx-2">
                      Automatic
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>
            By continuing, you agree to our{" "}
            <span
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => setTermsModalVisible(true)}
            >
              Terms and Conditions
            </span>
            .
          </p>
        </div>
        <Dialog
          visible={termsModalVisible}
          onHide={() => setTermsModalVisible(false)}
          modal
          dismissableMask
          header="Terms and Conditions"
        >
          <div>
            <ol>
              <li>
                <strong>Acceptance of Terms:</strong> By using our services, you
                agree to comply with and be bound by these Terms and Conditions.
              </li>
              <li>
                <strong>Use of Services:</strong> Our platform is intended for
                lawful purposes only. Any misuse, unauthorized access, or
                fraudulent activity is strictly prohibited.
              </li>
              <li>
                <strong>Privacy Policy:</strong> Your personal information is
                handled in accordance with our Privacy Policy. By continuing,
                you acknowledge and consent to our data practices.
              </li>
              <li>
                <strong>Intellectual Property:</strong> All content, trademarks,
                and materials on this platform are owned by us and may not be
                copied, modified, or distributed without permission.
              </li>
              <li>
                <strong>Limitation of Liability:</strong> We are not liable for
                any indirect, incidental, or consequential damages arising from
                the use of our services.
              </li>
            </ol>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default SingleLessonStep;
